'use strict';

// Dependancies
import "babel-polyfill"
import jump from 'jump.js';

const Network = require('./modules/network');
const Search = require('./modules/content.search');
const Tables = require('./modules/tables');

class App {

	constructor (){
  	if (document.querySelector('[data-toggle-submenu]')) {
    	this.networkSubmenus = document.querySelectorAll('ul.network ul');
  	}
  	if (document.querySelector('[data-toggle-body]')) {
    	this.bodyToggles = document.querySelectorAll('[data-toggle-body]');
    	for (var i = 0; i < this.bodyToggles.length; i++) {
      	this.bodyToggles[i].addEventListener('click', this.toggleBody.bind(this, this.bodyToggles[i]));
    	}
  	}
  	document.body.addEventListener('click', this.bodyClick.bind(this, document.body));

  	if (document.querySelector('nav.node')) {
    	this.jumpers = document.querySelectorAll('nav.node a');
    	for (var i = 0; i < this.jumpers.length; i++) {
      	this.jumpers[i].addEventListener('click', this.jumpLink.bind(this, this.jumpers[i]));
    	}
  	}
  	if (document.querySelector('a.top')) {
  	  document.querySelector('a.top').addEventListener('click', this.jumpLink.bind(this, document.querySelector('a.top')));
  	}

  	if (document.querySelectorAll('.node.recruiter').length) {
    	var r = Math.floor(Math.random() * document.querySelectorAll('.node.recruiter').length);
    	document.querySelectorAll('.node.recruiter')[r].classList.add('visible');
  	}
  	window.addEventListener('scroll', this.windowScroll.bind(this, window));
		this.Network = new Network();
		this.Search = new Search();
		this.Tables = new Tables();


	}

	bodyClick(el, e) {
  	if (e.target.hasAttribute('data-toggle-body')) {
    	this.toggleBody(e.target, e);
    } else if (e.target.hasAttribute('data-toggle-submenu')) {
      this.toggleSubmenu(e.target, e);
    } else if (e.target.hasAttribute('data-more')) {
      this.toggleMore(e.target, e);
    } else if (e.target.hasAttribute('data-expand')) {
      this.toggleExpand(e.target, e);
    } else if (e.target.hasAttribute('data-below')) {
      this.toggleBelow(e.target, e);
    }


	}

	toggleMore(el, e) {
  	el.previousElementSibling.classList.toggle('more');
  	if (el.previousElementSibling.classList.contains('more')) {
    	el.previousElementSibling.style.maxHeight = el.previousElementSibling.scrollHeight + 'px';
  	} else {
    	el.previousElementSibling.style.maxHeight = 0;
  	}
	}

	toggleBelow(el, e) {
  	e.preventDefault();
  	el.parentNode.classList.toggle('show--below');
	};



	toggleExpand(el, e) {
  	e.preventDefault();
  	el.parentNode.classList.toggle('active');
  	let t = el.nextElementSibling;
  	if (el.getAttribute('data-expand')) {
    	let p = el.parentNode;
    	let c = p.children;
    	for (var i = 0; i < c.length; i++) {
      	if (c[i].classList.contains(el.getAttribute('data-expand'))) {
        	t = c[i];
      	}
    	}
  	}

  	if (el.parentNode.classList.contains('active')) {
    	t.style.maxHeight = t.scrollHeight + 'px';
    	//setTimeout(function() {
      	//t.style.maxHeight = 'none';
    	//},750);
  	} else {
    	//if (t.style.maxHeight == 'none') {
      //	t.style.maxHeight = t.scrollHeight + 'px';
      //	setTimeout(function() {
      //  	t.style.maxHeight = 0;
      //	},20);

    	//} else {
      	t.style.maxHeight = 0;
    	//}
  	}
	}

	toggleBody(el, e) {
  	e.preventDefault();
  	e.stopPropagation();
  	var bodyClass = el.getAttribute('data-toggle-body');
  	document.body.classList.toggle(bodyClass);
	}
	toggleSubmenu(el, e) {
  	e.preventDefault();
  	document.body.classList.toggle('network--open');
  	if (el.classList.contains('microsite')) {
    	document.body.classList.add('network--submenu--microsite');
  	} else {
    	document.body.classList.remove('network--submenu--microsite');
  	}
  	var submenu = el.getAttribute('data-toggle-submenu');
  	for (var i = 0; i < this.networkSubmenus.length; i++) {
    	this.networkSubmenus[i].classList.remove('active');
  	}
  	document.getElementById(submenu).classList.add('active');
	}

	jumpLink(el, e) {
		e.preventDefault();
		jump(el.getAttribute('href'),{duration:400, offset: -100});
	}

	windowScroll(el, e) {
	  if (window.pageYOffset > 400) {
			document.body.classList.add('scrolled');
		} else {
			document.body.classList.remove('scrolled');
		}
	}

}

window.App = new App();
